import { render, staticRenderFns } from "./LearningGoalQuizShow.vue?vue&type=template&id=03bee1a5&"
import script from "./LearningGoalQuizShow.vue?vue&type=script&lang=js&"
export * from "./LearningGoalQuizShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports